import React from "react";
import { Breadcrumb, Dropdown } from "antd";

export default function BreadCrumb({
  breadList,
  header,
  info,
  btn,
  btnTitle,
  btnSvg,
  onClick,
  btnDropdown,
  settingItemsQuickActions,
}) {
  return (
    <>
      <div className="w-full flex flex-col md:flex-row items-start md:items-center justify-between bg-white gap-4">
        <div className="flex flex-col gap-[.75rem] w-full md:w-auto">
          <Breadcrumb separator="/" items={breadList} />
          <span className="heading_1 text-xl md:text-2xl lg:text-3xl">{header}</span>
          <span className="paragraph_1 text-sm md:text-base">{info}</span>
        </div>
        
        {btn && (
        <div className="flex justify-start md:justify-end w-auto md:w-auto">
            <button
              className="flex cstm-btn-2 items-center gap-x-2 w-auto justify-center text-sm md:text-base px-4 py-2"
              type="button"
              onClick={onClick}
            >
              <img src={btnSvg} alt="btnSvg" className="w-4 h-4 md:w-5 md:h-5" />
              <span className="whitespace-nowrap">{btnTitle}</span>
            </button>
          </div>
        )}

        {btnDropdown && (
          <div className="flex justify-start md:justify-end w-full md:w-auto">
            <Dropdown
              overlayStyle={{
                width: "200px",
              }}
              trigger={"click"}
              menu={{ items: settingItemsQuickActions }}
              placement="bottom"
            >
              <div className="w-auto">
                <button 
                  className="cstm-btn-2 flex gap-x-2 w-full justify-center items-center text-sm md:text-base px-4 py-2" 
                  type="submit"
                >
                  <img src={btnSvg} alt={btnSvg} className="w-4 h-4 md:w-5 md:h-5" />
                  <span className="whitespace-nowrap">{btnTitle}</span>
                </button>
              </div>
            </Dropdown>
          </div>
        )}
      </div>
    </>
  );
}